import React, { useEffect, useState } from 'react'
import {Button} from 'antd-mobile'
import Loading from 'components/Loading';
import { getBarcode } from '@/services'
import styles from './index.scss'

interface PriceProps {
  text?: string // 空显示文案
  iconUrl?: string
}

const showCardNo = (str) => {
  return str.split('').map((item, index) => {
    return index % 4 > 0 ? item : ' ' + item
  })
}
let timer: any = null
const useGetBarCode = () => {
  const [qrcode, setQrcode] = useState<any>('')
  const [time, setTime] = useState(60)
  //let timer: any = null
  let duration = 60000,
    resDuration = 60
  const repeatGetCode = function (getBarcode: any) {
    getBarcode((res: any) => {
      setQrcode({ ...res })
      duration = 60000
      resDuration = res.flushTime ? res.flushTime : 0
      resDuration && (duration = resDuration)

      timer = setInterval(() => {
        console.log(1111111)

        setTime((time) => {
          if (time === 1) {
            // requet 获取数字
            // setTime(Number(resDuration))
            clearInterval(timer)
            repeatGetCode(getBarcode)
            return Number(resDuration)
          }
          const _time = time - 1
          return _time
        })
      }, 1000)
    })
  }
  const clearGetCode = function () {
    clearInterval(timer)
    setTime(Number(resDuration))
  }

  return [qrcode, time, repeatGetCode, clearGetCode]
}

const Modal = (props: any) => {
  //const [time, setTime] = useState(60)
  const { lgData, showLogo, logo } = props || {}
  const [barCodeData, time, getBarCode, clearBarCode,] = useGetBarCode()

  const onModalClose = () => {
    clearBarCode()
    props.onClose()
  }
  useEffect(() => {
    console.log(props.getBarcode, 'props.getBarCodeprops.getBarCode')
    getBarCode(props.getBarcode)
    return () => {
      clearBarCode()
    }
  }, [])
  const regetBarCode = () => {

    clearBarCode()
    getBarCode(props.getBarcode)
  }
  return (
    <Loading loading={props.loading}>
    <div className={styles.modal} onClick={() => {}}>
      <div className={styles.selectModal}>
        <div className={styles.title}>
          {lgData.barTitle}
          <img
            className={styles.closeIcon}
            src={require('@/assets/images/close.png')}
            onClick={onModalClose}
          />
        </div>
        <div className={styles.infoBox}>
        {showLogo && <div className={styles.logoBox}><img className={styles.logo} src={logo || require('@/assets/images/comLogo.png')} /></div>}
          <div className={styles.card}>
            {barCodeData.barcode?showCardNo(String(barCodeData.barcode)) : <span style={{fontWeight: 400}}>{lgData.regetTip}<span style={{ color: '#5092e1'}} onClick={regetBarCode}>{lgData.regetBarCode}</span></span>}
          </div>
          <div className={styles.timeText}>
            <span className={styles.color}>{time}</span>
            {lgData.secondAfterTip}
          </div>
          <div className={styles.tip}>
          {lgData.barCodeTip}
          </div>
        </div>
      </div>
    </div>
    </Loading>
  )
}
const Empty = (props: any) => {
  const { loading, iconUrl, lgData, logo, showLogo } = props
  const [modalVisible, setModalVisible] = useState(false)

  const onClose = () => {
    setModalVisible(false)
  }
  return (
    <>
      <div
        className={styles.box}
        onClick={() => {
          setModalVisible(true)
        }}
      >
        <div className={styles.text}>{lgData.showBarCode}</div>
        <img
          className={styles.barIcon}
          src={iconUrl || require('./barMini.png')}
        />
      </div>
      {modalVisible && <Modal showLogo={showLogo} logo={logo} lgData={lgData} loading={loading} onClose={onClose} getBarcode={props.getBarcode}/>}
    </>
  )
}
export default Empty
